import { hasKey } from './hasKey';
import { isFunction } from './isFunction';

export function resolve(input, ...args) {
  if (isFunction(input)) return input(...args);
  if (hasKey(input, 'target')) return input.target.value;

  return input;
}
